module.exports = __webpack_public_path__ + "static/media/sel_20_275.795131e4.mp4";